<template>
  <div
    class="ts-mt-4 ts-p-4 ts-border ts-rounded-lg ts-border-gray-200 ts-flex ts-space-x-3"
  >
    <div>
      <p class="ts-uppercase ts-font-extrabold ts-text-blue-500">
        {{ $t('user.reachableWarehouse') }}
      </p>
    </div>
    <div
      class="
        ts-grid ts-grid-cols-1
        sm:ts-grid-cols-3
        lg:ts-grid-cols-5
        ts-gap-3 ts-w-full
      "
    >
      <div class="ts-w-full" v-for="(b, index) in branches" :key="index">
        <ul>
          <li>
            <i class="fa fa-building ts-mr-1"></i>
            <span class="ts-uppercase">{{ b.branch_name_en }}</span>
            <ul class="ts-pl-6 ts-pt-3">
              <li
                class="ts-flex ts-space-x-2"
                v-for="(w, index) in b.warehourses"
                :key="index"
              >
                <input
                  type="checkbox"
                  v-model.number="model.reachable_warehouses"
                  :id="w.location_id"
                  :value="w.location_id"
                />
                <label
                  :for="w.location_id"
                  class="ts-text-xs ts-text-gray-700"
                  >{{ w.location_name_en }}</label
                >
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'reachable-warehouse',
  props: ['value'],
  data() {
    return {
      model: {}
    }
  },
  computed: {
    branches() {
      return this.$store.state.security.user.branches.filter(
        b => b.warehourses.length > 0
      )
    }
  },
  created() {
    this.model = this.value
  }
}
</script>
